export default __webpack_public_path__ + "static/media/img_employee_tip7.441b506d.png";